// Glifos desenhados à mão (WEB-137), pros ícones que o pixelarticons não tem. Seguem a grade
// MEDIDA do pacote (e não uma grade par): coordenada inteira em 24x24, todo cheio e todo vão
// com pelo menos 2 unidades, só segmento ortogonal, diagonal em degraus de 2x2 que se tocam
// pelo canto, glifo centralizado (por isso a borda cai em par ou ímpar conforme o tamanho).
//
// Os que dizem "do pacote" partem de um ícone do pixelarticons 1.8.1 (MIT, licença em
// `pixelarticons.gen.ts`) e estendem o desenho dele.

/** Disco cheio. É o `CircleIcon` do radio e do dropdown, que o app usa como bolinha de 8 px. */
export const dot = 'M7 3h10v2h2v2h2v10h-2v2h-2v2h-10v-2h-2v-2h-2v-10h2v-2h2z';

/** `circle` do pacote com "!" dentro. */
export const circleAlert =
  'M7 3h10v2h-10zM5 5h2v2h-2zM17 5h2v2h-2zM3 7h2v10h-2zM11 7h2v6h-2zM19 7h2v10h-2zM11 15h2v2h-2zM5 17h2v2h-2zM17 17h2v2h-2zM7 19h10v2h-10z';

/** `circle` do pacote com "i" dentro. */
export const circleInfo =
  'M7 3h10v2h-10zM5 5h2v2h-2zM17 5h2v2h-2zM3 7h2v10h-2zM11 7h2v2h-2zM19 7h2v10h-2zM11 11h2v6h-2zM5 17h2v2h-2zM17 17h2v2h-2zM7 19h10v2h-10z';

/** Check gordo: o `check` do pacote com os degraus encostados pela aresta (o de lá some em 12 px). */
export const checkBold =
  'M16 6h4v2h-2v2h-2v2h-2v2h-2v2h-2v2h-2v-2h-2v-2h-2v-2h4v2h2v-2h2v-2h2v-2h2z';

/** X gordo, mesma regra do check: o `close` do pacote com os degraus encostados pela aresta. */
export const closeBold =
  'M4 5h4v2h2v2h4v-2h2v-2h4v2h-2v2h-2v2h-2v2h2v2h2v2h2v2h-4v-2h-2v-2h-4v2h-2v2h-4v-2h2v-2h2v-2h2v-2h-2v-2h-2v-2h-2z';

/** `circle` do pacote com o check gordo dentro (o `radio-on` de lá tem o check fino). */
export const circleCheck =
  'M7 3h10v2h-10zM5 5h2v2h-2zM17 5h2v2h-2zM3 7h2v10h-2zM19 7h2v10h-2zM13 9h4v2h-2v2h-2v2h-2v2h-2v-2h-2v-4h2v2h2v-2h2zM5 17h2v2h-2zM17 17h2v2h-2zM7 19h10v2h-10z';

/** `shield` do pacote com o check gordo dentro. */
export const shieldCheck =
  'M2 2h20v12h-2v-10h-16v10h-2zM13 6h4v2h-2v2h-2v2h-2v2h-2v-2h-2v-4h2v2h2v-2h2zM4 14h2v2h-2zM18 14h2v2h-2zM6 16h2v2h-2zM16 16h2v2h-2zM8 18h2v2h-2zM14 18h2v2h-2zM10 20h4v2h-4z';

/** `search` do pacote com um x na lente, como o `zoom-out` põe o sinal. */
export const searchX =
  'M6 2h8v2h-8zM4 4h2v2h-2zM14 4h2v2h-2zM2 6h2v8h-2zM16 6h2v8h-2zM7 7h2v2h-2zM11 7h2v2h-2zM9 9h2v2h-2zM7 11h2v2h-2zM11 11h2v2h-2zM4 14h2v2h-2zM14 14h2v2h-2zM6 16h8v2h-8zM16 16h2v2h-2zM18 18h2v2h-2zM20 20h2v2h-2z';

/** `mail-delete` do pacote com o x trocado por um mais. */
export const mailPlus =
  'M2 4h20v10h-2v-8h-16v12h10v2h-12zM6 8h2v2h-2zM16 8h2v2h-2zM8 10h2v2h-2zM14 10h2v2h-2zM10 12h4v2h-4zM18 16h2v2h2v2h-2v2h-2v-2h-2v-2h2z';

/** `file` do pacote com a ponta de uma seta pra cima. */
export const fileUp =
  'M3 2h12v2h2v2h-2v2h2v-2h2v2h2v14h-18zM5 4v16h14v-10h-6v-6zM11 12h2v2h2v2h-2v2h-2v-2h-2v-2h2zM7 16h2v2h-2zM15 16h2v2h-2z';

/** Seta diagonal, com o canto reforçado como no `external-link`. */
export const arrowUpRight =
  'M9 5h10v10h-2v-6h-2v-2h-6zM13 9h2v2h-2zM11 11h2v2h-2zM9 13h2v2h-2zM7 15h2v2h-2zM5 17h2v2h-2z';

/** Seta do `arrow-bar-down` virada pra cima, a linha fica embaixo. */
export const arrowUpFromLine =
  'M11 3h2v2h2v2h-2v8h-2v-8h-2v-2h2zM7 7h2v2h-2zM15 7h2v2h-2zM4 17h16v2h-16z';

/** Triângulo de atenção. O `alert` do pacote é um losango. */
export const triangleAlert =
  'M11 2h2v2h-2zM9 4h2v4h-2zM13 4h2v4h-2zM7 8h2v4h-2zM15 8h2v4h-2zM11 10h2v4h-2zM5 12h2v4h-2zM17 12h2v4h-2zM3 16h2v4h14v-4h2v4h2v2h-22v-2h2zM11 16h2v2h-2z';

/** Balança. O `scale` do pacote é uma seta de redimensionar. */
export const scale =
  'M11 3h2v2h8v4h-2v-2h-6v12h6v2h-14v-2h6v-12h-6v2h-2v-4h8zM1 9h2v4h2v-4h2v6h-6zM17 9h2v4h2v-4h2v6h-6z';

/** Chave deitada: argola grande à esquerda, dois dentes pra baixo. */
export const key =
  'M5 5h6v2h-6zM3 7h2v2h-2zM11 7h2v2h-2zM1 9h2v6h-2zM13 9h2v2h8v6h-2v-4h-2v4h-2v-4h-2v2h-2zM3 15h2v2h-2zM11 15h2v2h-2zM5 17h6v2h-6z';

/** Tomada de pé: dois pinos, corpo e fio. */
export const plug =
  'M7 2h2v4h6v-4h2v4h4v2h-2v6h-2v-6h-10v6h-2v-6h-2v-2h4zM7 14h2v2h-2zM15 14h2v2h-2zM9 16h6v2h-2v4h-2v-4h-2z';

/** Chip com dois pinos por lado e núcleo 2x2. */
export const cpu =
  'M8 2h2v2h4v-2h2v2h4v4h2v2h-2v4h2v2h-2v4h-4v2h-2v-2h-4v2h-2v-2h-4v-4h-2v-2h2v-4h-2v-2h2v-4h4zM6 6v12h12v-12zM10 10h4v4h-4z';

/** Três nós ligados em triângulo. */
export const webhook =
  'M9 4h6v6h-6zM11 6v2h2v-2zM7 10h2v2h-2zM15 10h2v2h-2zM5 12h2v4h10v-4h2v2h4v6h-6v-2h-10v2h-6v-6h4zM3 16v2h2v-2zM19 16v2h2v-2z';

/** Erlenmeyer com a linha do líquido. */
export const flask =
  'M7 2h10v2h-2v6h-2v-6h-2v6h-2v-6h-2zM7 10h2v4h6v-4h2v4h2v2h-14v-2h2zM3 16h2v4h14v-4h2v6h-18z';

/** Caixa em perspectiva isométrica. */
export const cube =
  'M9 1h6v2h-6zM5 3h4v2h-4zM15 3h4v2h-4zM1 5h4v2h-2v10h2v2h-4zM19 5h4v14h-4v-2h2v-10h-2zM5 7h4v2h-4zM15 7h4v2h-4zM9 9h6v2h-2v10h2v2h-6v-2h2v-10h-2zM5 19h4v2h-4zM15 19h4v2h-4z';

/** Aviãozinho de papel apontando pra direita. */
export const send =
  'M2 3h4v2h-2v4h-2zM6 5h4v2h-4zM10 7h4v2h-4zM4 9h2v2h-2zM14 9h4v2h4v2h-4v2h-4v-2h-8v-2h8zM4 13h2v2h-2zM2 15h2v4h2v2h-4zM10 15h4v2h-4zM6 17h4v2h-4z';

/** Quatro cantos de moldura e um rosto. */
export const scanFace =
  'M2 2h6v2h-4v4h-2zM16 2h6v6h-2v-4h-4zM8 8h2v2h-2zM14 8h2v2h-2zM8 14h8v2h-8zM2 16h2v4h4v2h-6zM20 16h2v6h-6v-2h4z';

/** Um caminho que se divide em duas setas. */
export const split =
  'M1 3h6v2h-2v2h-2v2h-2zM17 3h6v6h-2v-2h-2v-2h-2zM5 7h2v2h-2zM17 7h2v2h-2zM7 9h2v2h-2zM15 9h2v2h-2zM9 11h2v2h-2zM13 11h2v2h-2zM11 13h2v8h-2z';

/** Porte do `sliders-2` do pacote, que lá é traço e não path preenchido. */
export const sliders2 =
  'M6 5h6v2h10v2h-10v2h-6v-2h-4v-2h4zM8 7v2h2v-2zM12 13h6v2h4v2h-4v2h-6v-2h-10v-2h10zM14 15v2h2v-2z';

/** Lingotes da marca: um em cima de dois, com o brilho em vazado. */
export const ingot =
  'M9 5h6v2h2v4h-10v-4h2v2h2v-2h-2zM3 13h6v2h2v4h-10v-4h2v2h2v-2h-2zM15 13h6v2h2v4h-10v-4h2v2h2v-2h-2z';
